import { render, staticRenderFns } from "./LeadContact.vue?vue&type=template&id=4961bf4a&scoped=true&"
import script from "./LeadContact.vue?vue&type=script&lang=js&"
export * from "./LeadContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4961bf4a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VForm,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4961bf4a')) {
      api.createRecord('4961bf4a', component.options)
    } else {
      api.reload('4961bf4a', component.options)
    }
    module.hot.accept("./LeadContact.vue?vue&type=template&id=4961bf4a&scoped=true&", function () {
      api.rerender('4961bf4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/forms/v1/renderer/LeadContact.vue"
export default component.exports